<template>
  <div>
    <div class="form-row">
      <div class="col-12 mb-3">
        <TextBasicData class="d-flex justify-content-center" />
      </div>
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label for="nome"> Nome completo </label>
            <input
              class="form-control"
              v-model="Fields.nome"
              type="text"
              id="nome"
              name="nome"
              placeholder="Digite seu nome completo"
              @input="ErrorMessages.name = null"
            />
            <p
              class="error-message text-danger"
              v-if="ErrorMessages.name !== null"
            >
              {{ ErrorMessages.name }}
            </p>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label for="chooseTypePerson">Fazer cadastro como</label>
            <b-form-radio-group
              id="chooseTypePerson"
              name="chooseTypePerson"
              @change="ErrorMessages.typePerson = null"
            >
              <b-form-radio v-model="typePerson" value="physicalPerson">
                <a class="pointer">Pessoa Física</a>
              </b-form-radio>

              <b-form-radio v-model="typePerson" value="juridicPerson">
                <a class="pointer">Pessoa Jurídica</a>
              </b-form-radio>
            </b-form-radio-group>
            <p
              v-if="ErrorMessages.typePerson !== null"
              class="error-message text-danger"
            >
              {{ ErrorMessages.typePerson }}
            </p>
          </div>
        </div>
        <div class="col-12 col-md-6" v-if="typePerson === 'physicalPerson'">
          <div class="form-group">
            <label for="rg"> RG </label>
            <input
              type="text"
              class="form-control"
              id="rg"
              name="rg"
              v-model="Fields.rg"
              v-mask="'##.###.###-X'"
              aria-describedby="RG para Cadastro"
              placeholder="Digite seu RG"
              @input="ErrorMessages.rg = null"
            />
            <p
              class="error-message text-danger"
              v-if="ErrorMessages.rg !== null"
            >
              {{ ErrorMessages.rg }}
            </p>
          </div>
        </div>
        <div class="col-12 col-md-6" v-if="typePerson === 'physicalPerson'">
          <div class="form-group">
            <label for="cpf"> CPF </label>
            <input
              type="text"
              class="form-control"
              id="cpf"
              name="cpf"
              v-model="Fields.cpf"
              v-mask="'###.###.###-##'"
              aria-describedby="CPF para Cadastro"
              placeholder="Digite seu CPF"
              @input="ErrorMessages.cpf = null"
            />
            <p
              class="error-message text-danger"
              v-if="ErrorMessages.cpf !== null"
            >
              {{ ErrorMessages.cpf }}
            </p>
          </div>
        </div>
        <div class="col-12 col-md-6" v-if="typePerson === 'juridicPerson'">
          <div class="form-group">
            <label for="cnpj"> CNPJ </label>
            <input
              type="text"
              class="form-control"
              id="cnpj"
              name="cnpj"
              v-model="Fields.cnpj"
              v-mask="'##.###.###/####-##'"
              aria-describedby="CNPJ para Cadastro"
              placeholder="Digite seu CNPJ"
              @input="ErrorMessages.cnpj = null"
            />
            <p
              class="error-message text-danger"
              v-if="ErrorMessages.cnpj !== null"
            >
              {{ ErrorMessages.cnpj }}
            </p>
          </div>
        </div>
        <div class="col-12 col-md-6">
          <div class="form-group">
            <label for="celular"> Celular </label>
            <input
              type="tel"
              class="form-control"
              v-model="Fields.celular"
              id="celular"
              name="celular"
              v-mask="['(##) #####-####', '(##) ####-####']"
              aria-describedby="Celular para Cadastro"
              placeholder="Digite seu celular"
              @input="ErrorMessages.cellphone = null"
            />
            <p
              class="error-message text-danger"
              v-if="ErrorMessages.cellphone !== null"
            >
              {{ ErrorMessages.cellphone }}
            </p>
          </div>
        </div>
        <div class="col-12 col-md-6">
          <div class="form-group">
            <label for="telefone"> Telefone </label>
            <input
              type="tel"
              class="form-control"
              id="telefone"
              name="telefone"
              v-model="Fields.telefone"
              v-mask="'(##) ####-####'"
              aria-describedby="Telefone para Cadastro"
              placeholder="Digite seu telefone"
              @input="ErrorMessages.telephone = null"
            />
            <p
              class="error-message text-danger"
              v-if="ErrorMessages.telephone !== null"
            >
              {{ ErrorMessages.telephone }}
            </p>
          </div>
        </div>
        <div class="col-12 col-md-6">
          <div class="form-group">
            <label for="telefone2"> Telefone 2 (opcional) </label>
            <input
              type="tel"
              class="form-control"
              id="telefone2"
              name="telefone2"
              v-model="Fields.telefone2"
              v-mask="['(##) ####-####', '(##) #####-####']"
              aria-describedby="Telefone para Cadastro"
              placeholder="Digite seu telefone 2"
              @input="ErrorMessages.telephone2 = null"
            />
            <p
              class="error-message text-danger"
              v-if="ErrorMessages.telephone2 !== null"
            >
              {{ ErrorMessages.telephone2 }}
            </p>
          </div>
        </div>
        <div class="col-12 col-md-12">
          <SelectCitiesByUfId
            label="Cidades de atuação"
            :selectedCities.sync="Fields.id_cidades_atuacao"
            :errorMessage.sync="ErrorMessages.actuation_cities"
            :ufId="IbgeUfsId.SP"
            :isOptional="false"
          />
        </div>
      </div>
      <div class="col-12">
        <hr />
      </div>
      <div class="col-12">
        <TextAddress class="d-flex justify-content-center" />
      </div>
      <div class="col-12 col-md-3">
        <div class="form-group">
          <label for="cep"> CEP </label>
          <input
            type="text"
            class="form-control"
            id="cep"
            name="cep"
            v-model="Fields.cep"
            v-mask="'#####-###'"
            aria-describedby="CEP para Cadastro"
            placeholder="Digite seu CEP"
            @input="ErrorMessages.cep = null"
          />
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.cep !== null"
          >
            {{ ErrorMessages.cep }}
          </p>
        </div>
      </div>
      <div class="col-12 col-md-6">
        <div class="form-group">
          <label for="endereco"> Endereço </label>
          <input
            type="text"
            class="form-control"
            id="endereco"
            name="endereco"
            v-model="Fields.endereco"
            aria-describedby="Endereço para Cadastro"
            placeholder="Digite seu Endereço"
            @input="ErrorMessages.address = null"
            :disabled="
              !cepConsult.consulted ||
              (cepConsult.consulted && cepConsult.isValidAddress)
            "
          />
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.address !== null"
          >
            {{ ErrorMessages.address }}
          </p>
        </div>
      </div>
      <div class="col-12 col-md-3">
        <div class="form-group">
          <label for="numero"> Número </label>
          <input
            type="numeric"
            class="form-control"
            id="numero"
            name="numero"
            v-model="Fields.numero"
            v-mask="'####'"
            aria-describedby="Número para Cadastro"
            placeholder="Digite seu Número"
            @input="ErrorMessages.number = null"
          />
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.number !== null"
          >
            {{ ErrorMessages.number }}
          </p>
        </div>
      </div>
      <div class="col-6">
        <div class="form-group">
          <label for="bairro"> Bairro </label>
          <input
            type="text"
            class="form-control"
            id="bairro"
            name="bairro"
            v-model="Fields.bairro"
            aria-describedby="Bairro para cadastro"
            placeholder="Digite o bairro"
            @input="ErrorMessages.neighborhood = null"
            :disabled="
              !cepConsult.consulted ||
              (cepConsult.consulted && cepConsult.isValidNeighborhood)
            "
          />
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.neighborhood !== null"
          >
            {{ ErrorMessages.neighborhood }}
          </p>
        </div>
      </div>
      <div class="col-6 col-md-6">
        <div class="form-group">
          <label for="complemento"> Complemento (opcional) </label>
          <input
            type="text"
            class="form-control"
            id="complemento"
            name="complemento"
            v-model="Fields.complemento"
            aria-describedby="Complemento para Cadastro"
            placeholder="Digite seu Complemento"
          />
        </div>
      </div>
      <div class="col-6">
        <div class="form-group">
          <label for="cidade_id"> Cidade </label>
          <v-select
            disabled
            id="cidade_id"
            name="cidade_id"
            label="nome"
            placeholder="Selecione a cidade"
            class="no-search"
            v-model="Fields.cidade_id"
            :key="Fields.cidade_id"
            :options="getCities"
            :reduce="(city) => city.id"
            @input="ErrorMessages.city_id = null"
          >
            <div slot="no-options">Nenhuma cidade foi encontrada.</div>
          </v-select>
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.city_id !== null"
          >
            {{ ErrorMessages.city_id }}
          </p>
        </div>
      </div>
      <div class="col-6">
        <div class="form-group">
          <label for="estado_id"> Estado </label>
          <v-select
            disabled
            id="estado_id"
            name="estado_id"
            label="estado"
            placeholder="Selecione o estado"
            class="no-search"
            v-model="Fields.estado_id"
            :key="Fields.estado_id"
            @input="ErrorMessages.estado_id = null"
          >
            <div slot="no-options">Nenhum estado foi encontrado.</div>
          </v-select>
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.estado_id !== null"
          >
            {{ ErrorMessages.estado_id }}
          </p>
        </div>
      </div>
      <div class="col-12 mb-3">
        <hr class="mt-4 mb-2" />
        <TextAccess class="d-flex justify-content-center" />
      </div>
      <div class="col-12">
        <div class="form-group">
          <label for="email"> E-mail </label>
          <input
            type="email"
            class="form-control"
            id="email"
            name="email"
            v-model="Fields.email"
            aria-describedby="Email para acessar a plataforma"
            placeholder="Digite um E-mail para acessar a plataforma"
            @input="ErrorMessages.email = null"
          />
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.email !== null"
          >
            {{ ErrorMessages.email }}
          </p>
        </div>
      </div>

      <div class="col-12 col-md-6">
        <div class="form-group">
          <InputPassword
            :value.sync="Fields.password"
            :errorMessage.sync="ErrorMessages.password"
          />
        </div>
      </div>
      <div class="col-12 col-md-6">
        <InputPassword
          :label="'Confirme sua senha'"
          :value.sync="confirmPassword"
          :errorMessage.sync="ErrorMessages.confirmPassword"
          :placeholder="'Digite novamente a sua senha'"
        />
      </div>
      <div class="col-12 col-md-6 mt-3">
        <div class="form-group">
          <b-form-checkbox
            id="termos"
            name="termsAndConditions"
            v-model="acceptedTermsAndConditions"
            @change="ErrorMessages.termsAndConditions = null"
          >
            <span class="font-weight-normal">
              Li e aceito os termos e condições.
            </span>
            <span class="c-orange c-pointer" v-b-modal="'termos'"
              >Ver termos</span
            >
          </b-form-checkbox>
          <p
            v-if="ErrorMessages.termsAndConditions !== null"
            class="error-message text-danger"
          >
            {{ ErrorMessages.termsAndConditions }}
          </p>

          <b-form-checkbox
            id="politicaPrivacidade"
            name="privacyPolicy"
            v-model="acceptedPrivacyPolicy"
            @input="ErrorMessages.privacyPolicy = null"
          >
            <span class="font-weight-normal">
              Li e aceito a política de privacidade.
            </span>
            <span class="c-orange c-pointer" v-b-modal="'politicaPrivacidade'">
              Ver termos
            </span>
          </b-form-checkbox>
          <p
            v-if="ErrorMessages.privacyPolicy !== null"
            class="error-message text-danger"
          >
            {{ ErrorMessages.privacyPolicy }}
          </p>
        </div>
      </div>
    </div>
    <button
      type="submit"
      class="btn bg-orange text-white my-3 text-uppercase"
      @click="register()"
    >
      Cadastrar
    </button>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import IbgeUfsId from '../../enums/General/IbgeUfsId';
import makeToast from '../../mixins/makeToast';
import login from '../../mixins/login';
import SelectCitiesByUfId from '../../components/Selects/SelectCitiesByUfId.vue';
import TextAccess from '../../components/Register/TextAccess.vue';
import TextBasicData from '../../components/Register/TextBasicData.vue';
import TextAddress from '../../components/Register/TextAddress.vue';
import InputPassword from '../../components/Inputs/InputPassword.vue';

export default {
  name: 'AffiliateRegister',
  mixins: [makeToast, login],
  props: {
    segments: {
      type: Array,
      required: true,
    },
    externo: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    SelectCitiesByUfId,
    TextAccess,
    TextBasicData,
    TextAddress,
    InputPassword,
  },
  data() {
    return {
      IbgeUfsId,
      Fields: {
        email: null,
        password: null,
        cpf: null,
        rg: null,
        cnpj: null,
        nome: null,
        celular: null,
        telefone: null,
        telefone2: null,
        endereco: null,
        numero: null,
        complemento: null,
        cep: null,
        bairro: null,
        cidade_id: null,
        estado_id: null,
        id_cidades_atuacao: [],
        externo: this.externo,
      },
      ErrorMessages: {
        email: null,
        password: null,
        confirmPassword: null,
        typePerson: null,
        cpf: null,
        rg: null,
        cnpj: null,
        name: null,
        cellphone: null,
        telephone: null,
        telephone2: null,
        address: null,
        number: null,
        cep: null,
        neighborhood: null,
        city_id: null,
        estado_id: null,
        actuation_cities: null,
        termsAndConditions: null,
        privacyPolicy: null,
      },
      cepConsult: {
        consulted: false,
        isValidAddress: true,
        isValidNeighborhood: true,
      },
      typePerson: null,
      confirmPassword: null,
      acceptedTermsAndConditions: false,
      acceptedPrivacyPolicy: false,
      loading: false,
    };
  },
  mounted() {
    this.getAllCities();
  },
  computed: {
    ...mapGetters('general', ['getCities']),
    ...mapState(['dadosUsuario']),
    acceptedFilesTypes: () => [
      'application/pdf',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    ],
  },
  watch: {
    'Fields.cep': function () {
      this.consultCep();
    },
  },
  methods: {
    ...mapActions('general', ['getAllCities']),
    ...mapActions('partner', ['registerPartner']),
    register() {
      if (this.validateFields()) {
        this.$store.dispatch('startLoader');

        this.registerPartner(this.Fields)
          .then(() => {
            this.makeToast('Sucesso!', 'Cadastro realizado com sucesso!');
            setTimeout(() => {
              this.login(this.Fields.email, this.Fields.password);
            }, 1000);
          })
          .catch((error) => {
            this.makeToast('Oopss!', error.response.data.message, 'danger');
          })
          .finally(() => {
            this.$store.dispatch('endLoader');
          });
      } else {
        this.makeToast(
          'Oopss!',
          'Parece que há campos inválidos! Corrija-os e tente novamente',
          'danger'
        );
      }
    },
    consultCep() {
      if (!this.loading && this.Fields.cep.length === 9) {
        this.loading = true;
        this.$store.dispatch('startLoader');

        this.$store
          .dispatch('user/consultCep', this.Fields.cep)
          .then(async (response) => {
            this.validateCepResults(response.data);
          })
          .catch((error) => {
            this.makeToast('Oopss!', error.response.data.message, 'danger');
          })
          .finally(() => {
            this.loading = false;
            this.$store.dispatch('endLoader');
          });
      }

      if (this.Fields.cep.length === 0) {
        this.cepConsult.consulted = false;
        this.Fields.endereco = null;
        this.Fields.bairro = null;
        this.Fields.cidade_id = null;
        this.Fields.estado_id = null;
      }
    },
    validateFields() {
      let isValid = true;

      if (
        this.typePerson === null &&
        this.typePerson !== 'physicalPerson' &&
        this.typePerson !== 'juridicPerson'
      ) {
        this.ErrorMessages.typePerson =
          'Por favor, selecione o tipo de cadastro';
        isValid = false;
      }

      if (!this.$validate.name(this.Fields.nome)) {
        this.ErrorMessages.name = 'Nome inválido';
        isValid = false;
      }

      if (this.typePerson === 'physicalPerson') {
        if (!this.$validate.rg(this.Fields.rg)) {
          this.ErrorMessages.rg = 'RG inválido';
          isValid = false;
        }

        if (!this.$validate.cpf(this.Fields.cpf)) {
          this.ErrorMessages.cpf = 'CPF inválido';
          isValid = false;
        }
      }

      if (this.typePerson === 'juridicPerson') {
        if (!this.$validate.cnpj(this.Fields.cnpj)) {
          this.ErrorMessages.cnpj = 'CNPJ inválido';
          isValid = false;
        }
      }

      if (!this.$validate.telephone(this.Fields.celular)) {
        this.ErrorMessages.cellphone = 'Celular inválido';
        isValid = false;
      }

      if (!this.$validate.telephone(this.Fields.telefone)) {
        this.ErrorMessages.telephone = 'Telefone inválido';
        isValid = false;
      }

      if (
        this.Fields.telefone2 !== null &&
        this.Fields.telefone2.length > 0 &&
        !this.$validate.telephone(this.Fields.telefone2)
      ) {
        this.ErrorMessages.telephone2 = 'Telefone 2 inválido';
        isValid = false;
      }

      if (!this.$validate.address(this.Fields.endereco)) {
        this.ErrorMessages.address =
          'Endereço inválido, digite um com no mínimo 5 e no máximo 70 caracteres';
        isValid = false;
      }

      if (!this.$validate.cep(this.Fields.cep)) {
        this.ErrorMessages.cep = 'CEP inválido';
        isValid = false;
      }

      if (!this.$validate.address(this.Fields.bairro)) {
        this.ErrorMessages.neighborhood =
          'Bairro inválido, digite com no máximo 40 caracteres';
        isValid = false;
      }

      if (!this.$validate.addressNumber(this.Fields.numero)) {
        this.ErrorMessages.number = 'Número inválido';
        isValid = false;
      }

      if (this.Fields.cidade_id === null) {
        this.ErrorMessages.city_id = 'Você não selecionou nenhuma cidade';
        isValid = false;
      }

      if (this.Fields.estado_id === null) {
        this.ErrorMessages.estado_id = 'Você não selecionou nenhum estado';
        isValid = false;
      }

      if (this.Fields.id_cidades_atuacao.length === 0) {
        this.ErrorMessages.actuation_cities =
          'Você não selecionou nenhuma cidade de atuação';
        isValid = false;
      }

      if (!this.$validate.email(this.Fields.email)) {
        this.ErrorMessages.email = 'Email inválido';
        isValid = false;
      }

      if (!this.$validate.password(this.Fields.password)) {
        this.ErrorMessages.password =
          'A senha precisa ter no mínimo 5 caracteres';
        isValid = false;
      }

      if (this.confirmPassword !== this.Fields.password) {
        this.ErrorMessages.confirmPassword = 'As senhas devem ser iguais';
        isValid = false;
      }

      if (!this.acceptedPrivacyPolicy) {
        this.ErrorMessages.privacyPolicy =
          'Você precisa aceitar a política de privacidade';
        isValid = false;
      }

      if (!this.acceptedTermsAndConditions) {
        this.ErrorMessages.termsAndConditions =
          'Você precisa aceitar os termos e condições';
        isValid = false;
      }

      return isValid;
    },
    uploadResume() {
      const elResumeFile = document.getElementById('resume').files;
      if (elResumeFile.length === 1) {
        const invalidFileErrors = this.$validate.files(
          elResumeFile,
          1,
          this.acceptedFilesTypes
        );

        if (invalidFileErrors.length !== 0) {
          invalidFileErrors.forEach((message) =>
            this.makeToast('Oops!', message, 'danger')
          );
          return false;
        }

        const formData = new FormData();
        formData.append('resume', elResumeFile[0]);

        this.$store.dispatch('startLoader');

        this.$store
          .dispatch('files/uploadResume', formData)
          .then((response) => {
            this.Fields.curriculo = response.data.data;
            this.makeToast('Sucesso!', 'Currículo anexado com sucesso!');
            this.$store.dispatch('endLoader');
          })
          .catch(() => {
            this.makeToast(
              'Oopss!',
              'Parece que houve um erro ao anexar o currículo, tente novamente mais tarde',
              'danger'
            );
            this.$store.dispatch('endLoader');
          });
      }

      return true;
    },
    validateCepResults(result) {
      this.cepConsult.consulted = true;

      this.cepConsult.isValidAddress = !!result.logradouro;

      this.cepConsult.isValidNeighborhood = !!result.bairro;

      this.Fields.endereco = result.logradouro || null;
      this.Fields.bairro = result.bairro || null;
      this.Fields.cidade_id = result.cidade_id || null;
      this.Fields.estado_id = result.uf || null;

      this.ErrorMessages.address = null;
      this.ErrorMessages.neighborhood = null;
      this.ErrorMessages.city_id = null;
      this.ErrorMessages.estado_id = null;
    },
  },
};
</script>

<style scoped>
div.form-group label {
  font-weight: 700;
}

div.col-12 label {
  font-weight: 700;
}

.no-search .vs_search {
  background: transparent;
}

.character-count {
  box-shadow: 2px 2px 8px var(--orange-primary);
  background-color: var(--orange-primary);
  color: #fff;
  font-size: 14px;
  padding: 5px;
  border-radius: 4px;
  vertical-align: middle;
  text-align: center;
  margin-bottom: 10px;
}

.error-message {
  display: flex;
  align-items: center;
  padding: 6px 12px;
  background-color: #f8d7da;
  border-radius: 0 0 5px 5px;
}
</style>
